import { render, staticRenderFns } from "./LinkPanel.vue?vue&type=template&id=f1568afe&scoped=true&"
import script from "./LinkPanel.vue?vue&type=script&lang=js&"
export * from "./LinkPanel.vue?vue&type=script&lang=js&"
import style0 from "./LinkPanel.vue?vue&type=style&index=0&id=f1568afe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1568afe",
  null
  
)

export default component.exports